export default __webpack_public_path__ + "static/APS-4eb375eceef4bab16dff11e5e905f0df.svg";